import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const sendManualMessageInput = z.object({
  conversationId: zExt.objectId(),
  content: z.string().min(1),
  category: createEnum(categories),
});

const sendManualMessageOutput = z.object({
  success: z.boolean(),
  messageId: z.string().optional(),
  errorMessage: z.string().optional(),
});

export const adminSendManualMessage = {
  name: "adminSendManualMessage" as const,
  input: sendManualMessageInput,
  output: sendManualMessageOutput,
};

export const contractorSendManualMessage = {
  name: "contractorSendManualMessage" as const,
  input: sendManualMessageInput,
  output: sendManualMessageOutput,
};
